import { useEffect, useState } from "react";
import Cardsimple from "../../cards/Cardsimple"
import getEstadoEquipamiento from "../../services/dashboard/getEstadoEquipamiento";
import { Helmet, HelmetProvider } from "react-helmet-async";
import GraficoEquipamiento from "./GaficoEquipamiento";
import TablaEquipamiento from "./TablaEquipamiento";
import TopCards from "./TopCards";


const DashInventario = () => {

    const FILTROS = [
        { name: "Alta Tecnología", check: true },
        { name: "Biomedico", check: true },
        { name: "Electromecánico", check: true },
        { name: "Complementario", check: true },
        //{ name: "Instalaciones", check: false },
        //{ name: "Mobiliario", check: false },
        //{ name: "Informático", check: false },
        //{ name: "Estratégicos", check: true },
    ]

    const [isLoading, setIsLoading] = useState(true);
    const [dataTable, setDataTable] = useState();
    const [checkedState, setCheckedState] = useState(
        new Array(FILTROS.length).fill(false).map((_, index) => FILTROS[index].check !== undefined ? FILTROS[index].check : false)
    );

    useEffect(() => {
        getEstadoEquipamiento(checkedState)
            .then((data) => {
                setIsLoading(false)
                setDataTable(data)                
            })
    }, [checkedState])

    let grafico_data = []
    let tabla_data = []
    let tabla_totales = []
    if (dataTable) {
        grafico_data = dataTable.grafico_data
        tabla_data = dataTable.tabla_data
        tabla_totales = dataTable.tabla_totales
    }

    const handleOnChange = (position) => {
        if (position != 7) {
            setIsLoading(true)
            const updatedCheckedState = checkedState.map((item, index) =>
                index === position ? !item : item
            );
            setCheckedState(updatedCheckedState);
        }
    }
    
    return (
        <>
            {(dataTable) && <TopCards tabla_totales={tabla_totales} />}

            <Cardsimple style="card-info" header={<div className="text-bold"><i className="fas fa-chart-pie mr-1"></i> ESTADO DEL EQUIPAMIENTO</div>} condensed={true}>
                <div className="row">
                    <div className="col-12">
                        <div className="form-inline align-items-center border-bottom p-1 bg-light">
                            {
                                FILTROS.map(({ name, check }, index) => {
                                    return (
                                        <div className="col-auto" key={index}>
                                            <div className={`custom-control custom-switch mb-0 mr-sm-2 ${(index == 7) && ("custom-switch-off-danger custom-switch-on-success")}`}>
                                                <input className="custom-control-input " type="checkbox"
                                                    name={name}
                                                    value={check}
                                                    checked={checkedState[index]}
                                                    onChange={() => handleOnChange(index)} id={`custom-checkbox-${index}`} disabled={isLoading} />
                                                <label className="custom-control-label font-weight-normal text-xs pt-1" htmlFor={`custom-checkbox-${index}`}>
                                                    {name}
                                                </label>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        {(dataTable) && <GraficoEquipamiento grafico_data={grafico_data} />}
                    </div>
                    <div className="col-md-6 col-12 border-left">
                        <div className="p-0 p-md-4">
                            {(dataTable) && <TablaEquipamiento tablaData={tabla_data} tablaTotales={tabla_totales} />}
                        </div>
                    </div>
                </div>
            </Cardsimple>
        </>
    )
}

export default DashInventario